export  const memberRegistration = {
    0: "NDC MEMBERSHIP STATUS",
    1: "PERSONAL INFORMATION",
    2: "CONTACT INFORMATION",
    3: "REGION & CONSTITUENCY",
    4: "EDUCATION BACKGROUND",
    5: "PROFESSION & OCCUPATION",
    6: "CONFIRMATION",
};

export const registrationForms = {
    memberRegistration,
}
